import classnames from 'classnames';
import React from 'react';
import { Container, Nav } from 'react-bootstrap';

import TabItem from './sub-components/tab-item';
import './tab-nav.scss';
import { TabNavProps } from './types';

const TabNav: React.FC<TabNavProps> = ({ activeKey, onSelect, getStickyPositionTop, metadata, children }) => {
  const [isSticky, setIsSticky] = React.useState(false);
  const [stickyPositionTop, setStickyPositionTop] = React.useState(getStickyPositionTop ? getStickyPositionTop() : 0);
  const ref = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    const initialPositionTop = ref.current?.offsetTop || 0;

    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const positionTop = getStickyPositionTop ? getStickyPositionTop() : 0;
      if (scrollTop > initialPositionTop - positionTop) {
        setStickyPositionTop(positionTop);
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      {isSticky && <div className="tabs-navigator-placeholder" />}
      <div
        ref={ref}
        style={{ top: stickyPositionTop }}
        className={classnames('tabs-navigator-root', { sticky: isSticky })}
        {...metadata}
      >
        <Container className="tabs-navigator-body">
          <Nav variant="tabs" activeKey={activeKey} onSelect={onSelect}>
            {children}
          </Nav>
        </Container>
      </div>
    </>
  );
};

TabNav.displayName = 'TabNav';

export default Object.assign(TabNav, {
  Item: TabItem,
});
